import { AbstractModuleAdapter } from "../abstract";
import { Direction, ModuleConnectorAdapter } from "../connector";
export class ModuleMultiplierAdapter extends AbstractModuleAdapter {
    #voltageInputX;
    #voltageInputY;
    #voltageOutput;
    constructor(context, box) {
        super(context, box);
        this.#voltageInputX = ModuleConnectorAdapter.create(context.boxAdapters, box.voltageInputX, Direction.Input, "X");
        this.#voltageInputY = ModuleConnectorAdapter.create(context.boxAdapters, box.voltageInputY, Direction.Input, "Y");
        this.#voltageOutput = ModuleConnectorAdapter.create(context.boxAdapters, box.voltageOutput, Direction.Output, "Result");
    }
    get inputs() {
        return [this.#voltageInputX, this.#voltageInputY];
    }
    get outputs() {
        return [this.#voltageOutput];
    }
}
